import { Component, OnChanges, ViewEncapsulation, Directive, ElementRef, Input, OnInit } from '@angular/core';
import { SwiperOptions } from 'swiper';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators, AbstractControl } from '@angular/forms';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Renderer2 } from '@angular/core';
import { noop, Observable, Observer, of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { apiService } from 'app/services/api.service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale, enGbLocale } from 'ngx-bootstrap/chronos';
import { arLocale } from 'ngx-bootstrap/locale';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, transition, style, animate } from '@angular/animations';
import { OriginDestinations, Travellers } from '@core/interfaces/flight';

@Component({
  selector: 'app-flight-search',
  templateUrl: './flight-search.component.html',
  styleUrls: ['./flight-search.component.scss']
})
export class FlightSearchComponent implements OnInit, OnChanges {
  bsConfig: object;
  flightSearch: FormGroup;
  dynamicDivs: any[] = [];
  FromAirportDataSource: Observable<any>;
  FromAirportDataSource0: Observable<any>;
  ToAirportDataSource: Observable<any>;
  errorMessage?: string;
  minDate = new Date();
  submitted = false;
  searchFormReq = null;
  fromLocation: any;
  toLocation: any;
  isDirect: boolean = false;
  isBaggage: boolean = false;
  fromAirportNoResult = false;
  fromMultiAirportNoResult: boolean[] = [];
  toMultiAirportNoResult: boolean[] = [];

  fromLocationMulti: any[] = [];
  toLocationMulti: any[] = [];

  toAirportNoResult = false;
  recentSearches: any[] = [];

  fromAirport2?: string;
  toAirport2?: string;
  departureDate2 = new Date();
  fromAirport3?: string;
  toAirport3?: string;
  departureDate3 = new Date();
  fromAirport4?: string;
  toAirport4?: string;
  departureDate4 = new Date();
  today: Date;
  maxDate: Date;
  returnDateMinimum: Date;
  departureDates: Date[] = [new Date()];
  isAddingMultiCity: boolean = false;
  travellers: Travellers[] = [];
  // pricing calender
  currentYear: number;
  currentMonth: number;
  months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  daysOfWeek: string[] = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  prices: number[] = [50, 100, 120, 130, 110, 140, 150, 160, 155, 145, 135, 125, 115]; // Dummy prices in SAR
  calendarDays: any[] = [];
  searchRequestType: string;
  isOneWayActive = true; // Track if One Way tab is active
  isRoundTripActive = false; // Track if Round Trip tab is active
  isMultiCityActive = false; // Track if Multi City tab is active
  isOtherDivHidden = false; // Determine whether to hide the other div
  recentSearchDetails: any[];

  multiCityForm: FormGroup;

  travelClass: any = [
    {
      id: 0,
      displayName: "ECONOMY",
      name: "ECONOMY"
    },
    {
      id: 1,
      displayName: "PREMIUM ECONOMY",
      name: "PREMIUM_ECONOMY"
    },
    {
      id: 2,
      displayName: "BUSINESS",
      name: "BUSINESS"
    },
    {
      id: 3,
      displayName: "FIRST",
      name: "FIRST"
    },
  ]

  selectedTravelClass: string = "ECONOMY";
  colorvariable: number = 0;

  @Input() flightResposeData = null;
  @Input() airlineList: any[] = [];
  @Input() layoverData: any;
  @Input() requestParams: any;
  @Input() originDestinations: OriginDestinations[] = [];
  @Input() oneWaySummary: any;
  @Input() roundTripSummary: any;
  @Input() multiCitySummary: any;
  @Input() filghtInfo: any[] = [];
  @Input() filghtInfoFilter: any[] = [];
  @Input() airlineMinPriceList: any[] = [];
  @Input() airlineDistinctData: any[] = [];
  @Input() changeFromFilters: boolean = false;
  @Input() flightDataFound: boolean = false;

  constructor(private _apiService: apiService,
    private localeService: BsLocaleService,
    private fb: FormBuilder,
    private renderer: Renderer2,
    private router: Router,
    public activatedRoute: ActivatedRoute) {
    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 365);

    this.createForm();
  }
  bsValue = new Date();

  ngOnChanges(): void {
    console.log('this.flightResposeData', this.flightResposeData);
    // if (this.flightResposeData && !this.changeFromFilters)  

    if (this.flightResposeData)
      this.autoFillData(this.flightResposeData);
  }

  get multiCityArray(): FormArray {
    return this.multiCityForm.get('multiCityArray') as FormArray;
  }

  addMultiCity() {
    if (this.multiCityArray.length <= 4) {
      this.multiCityArray.push(this.fb.group({
        fromAirport: new FormControl(''),
        airportCodeFrom: new FormControl(''),
        airportCodeTo: new FormControl(''),
        toAirport: new FormControl(''),
        departureDate: new FormControl('')
      }));

      let formatedFromAirport = {
        airport_ar: '',
        airport_code: '',
        airport_en: '',
        city_ar: '',
        city_en: '',
        country_ar: '',
        country_en: '',
        display_name_ar: '',
        display_name_en: '',
        id: '',
        latitude: '',
        longitude: '',
      }
      let formatedToAirport = {
        airport_ar: '',
        airport_code: '',
        airport_en: '',
        city_ar: '',
        city_en: '',
        country_ar: '',
        country_en: '',
        display_name_ar: '',
        display_name_en: '',
        id: '',
        latitude: '',
        longitude: '',
      }
      this.fromLocationMulti.push(formatedFromAirport);
      this.toLocationMulti.push(formatedToAirport);
    }

    if (this.multiCityArray.length >= 5) {
      this.showAddButton = false;
    }
  }

  ngOnInit(): void {

    this.flightSearch = new FormGroup({
      fromAirport: new FormControl(''),
      toAirport: new FormControl('', Validators.required),
      departureDate: new FormControl('', Validators.required),
      returnDate: new FormControl('', Validators.required)
    });

    this.multiCityForm = this.fb.group({
      multiCityArray: this.fb.array([]) // Initialize an empty FormArray
    });

    const storedSearches = localStorage.getItem('recentFlightSearches');
    this.recentSearches = storedSearches ? JSON.parse(storedSearches) : [];
    if (this.recentSearches.length > 0 && this.router.url === '/home') {
      this.recentSearchAutoFill(this.recentSearches);
    }

    this.isRtl = String(localStorage.getItem('languageCode')) === 'ar';

    // Set the locale based on the value of 'isRtl'
    if (this.isRtl) {
      defineLocale('ar', arLocale);
      this.localeService.use('ar'); // Set locale dynamically
    } else {
      defineLocale('en-gb', enGbLocale);
      this.localeService.use('en-gb'); // Set locale dynamically
    }

    // Set the locale for the datepicker
    this.bsConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      containerClass: 'theme-red',
      showWeekNumbers: false,
      locale: this.isRtl ? 'ar' : 'en-gb',
    };

    // this.onValueChange(new Date());
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    /* code for from airport search using API */
    this.FromAirportDataSource = new Observable((observer: Observer<string | undefined>) => {
      observer.next(this.flightSearch.get('fromAirport')?.value);
    }).pipe(
      switchMap((query: string) => {
        if (query && query.length >= 3) {
          console.log(this._apiService.searchAirport(query));
          let resp = this._apiService.searchAirport(query).pipe(
            map((data) => data && data.data || [])
          );
          console.log(resp);
          return resp;
        }
        return of([]);
      })
    );
    this.ToAirportDataSource = new Observable((observer: Observer<string | undefined>) => {
      observer.next(this.flightSearch.get('toAirport')?.value);
    }).pipe(
      switchMap((query: string) => {
        if (query && query.length >= 3) {
          console.log(this._apiService.searchAirport(query));
          let resp = this._apiService.searchAirport(query).pipe(
            map((data) => data && data.data || [])
          );
          console.log(resp);
          return resp;
        }
        return of([]);
      })
    );
    const body = document.getElementsByTagName('body')[0];
    if (body.classList.contains('rtl-direction')) {
      this.isRtl = true;
    } else {
      this.isRtl = false;
    }

    // this.myDatepicker = this.fb.group({
    //   dateYMD: null // You can set an initial date if needed
    // });

    // this.myDatepicker = this.fb.group({
    //   date: null,
    //   range: null
    // });
    this.myDateValue = new Date();
  }

  recentSearchAutoFill(data: any) {
    console.log("home recent fill called")
    this.bsConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      containerClass: 'theme-red',
      showWeekNumbers: false,
      locale: this.isRtl ? 'ar' : 'en-gb',
    };
    let recentDetails = this.recentSearches[0];
    let recentAdultCount = recentDetails.adult;
    let recentChildCount = recentDetails.child;
    let recentInfantCount = recentDetails.infant;

    if (recentDetails.adult !== "0") {
      this.travellers.push({
        "type": "ADULT",
        "count": recentDetails.adult
      });
      this.adultCount = parseInt(recentDetails.adult)
    }
    if (recentDetails.child !== "0") {
      this.travellers.push({
        "type": "CHILD",
        "count": recentDetails.child
      });
      this.childCount = parseInt(recentDetails.child)
    }
    if (recentDetails.infant !== "0") {
      this.travellers.push({
        "type": "HELD_INFANT",
        "count": recentDetails.infant
      });
      this.infantCount = parseInt(recentDetails.infant)
    }

    this.selectedTravelClass = recentDetails.travelClass.replace('_', ' ')

    if (this.recentSearches.length > 0) {
      const searchType = this.recentSearches[0].searchType;
      console.log('this.recentSearches', searchType);
      // Reset all classes to false initially
      this.isOneWayActive = false;
      this.isRoundTripActive = false;
      this.isMultiCityActive = false;
      this.isRadioActive = false;
      if (searchType === "one-way") {
        // For One Way trip
        this.isOneWayActive = true;
        this.isRadioActive = true;
        let recentFromAirport = recentDetails.fromLocation;
        let recentToAirport = recentDetails.toLocation;
        let recentDepartureDate = recentDetails.departureDate;

        this.roundTripSummary = {
          departureFlight: {
            fromAirport: recentFromAirport,
            toAirport: recentToAirport,
            departureDate: recentDepartureDate,
          },
          adultCount: recentAdultCount,
          childCount: recentChildCount,
          infantCount: recentInfantCount
        }
        let formatedFromAirport = {
          airport_ar: '',
          airport_code: recentDetails.fromLocation.airport_code,
          airport_en: recentDetails.fromLocation.airport_en,
          city_ar: '',
          city_en: recentDetails.fromLocation.city_en,
          country_ar: '',
          country_en: recentDetails.fromLocation.country_en,
          display_name_ar: '',
          display_name_en: recentDetails.fromLocation.display_name_en,
          id: '',
          latitude: '',
          longitude: '',
        }
        let formatedToAirport = {
          airport_ar: '',
          airport_code: recentDetails.toLocation.airport_code,
          airport_en: recentDetails.toLocation.airport_en,
          city_ar: '',
          city_en: recentDetails.toLocation.city_en,
          country_ar: '',
          country_en: recentDetails.toLocation.country_en,
          display_name_ar: '',
          display_name_en: recentDetails.toLocation.display_name_en,
          id: '',
          latitude: '',
          longitude: '',
        }
        this.fromLocation = formatedFromAirport;
        this.toLocation = formatedToAirport;
        this.flightSearch.get('fromAirport')?.setValue(formatedFromAirport.display_name_en);
        this.flightSearch.get('toAirport')?.setValue(formatedToAirport.display_name_en);
        this.flightSearch.get('departureDate')?.setValue(new Date(recentDepartureDate));
        this.flightSearch.get('returnDate')?.setValue(new Date(recentDepartureDate));
        this.updateReturnDate();

      } else if (searchType === "round-trip") {
        this.isRoundTripActive = true;
        this.isRadioActive = false;
        let recentFromAirport = recentDetails.fromLocation;
        let recentToAirport = recentDetails.toLocation;
        let recentDepartureDate = recentDetails.departureDate;
        let recentReturnDate = recentDetails.returnDate;
        console.log('recentDepartureDate', recentDepartureDate)
        this.roundTripSummary = {
          departureFlight: {
            fromAirport: recentFromAirport,
            toAirport: recentToAirport,
            departureDate: recentDepartureDate,
          },
          returnFlight: {
            returnDate: recentReturnDate,
          },
          adultCount: recentAdultCount,
          childCount: recentChildCount,
          infantCount: recentInfantCount
        }
        let formatedFromAirport = {
          airport_ar: '',
          airport_code: recentDetails.fromLocation.airport_code,
          airport_en: recentDetails.fromLocation.airport_en,
          city_ar: '',
          city_en: recentDetails.fromLocation.city_en,
          country_ar: '',
          country_en: recentDetails.fromLocation.country_en,
          display_name_ar: '',
          display_name_en: recentDetails.fromLocation.display_name_en,
          id: '',
          latitude: '',
          longitude: '',
        }
        let formatedToAirport = {
          airport_ar: '',
          airport_code: recentDetails.toLocation.airport_code,
          airport_en: recentDetails.toLocation.airport_en,
          city_ar: '',
          city_en: recentDetails.toLocation.city_en,
          country_ar: '',
          country_en: recentDetails.toLocation.country_en,
          display_name_ar: '',
          display_name_en: recentDetails.toLocation.display_name_en,
          id: '',
          latitude: '',
          longitude: '',
        }
        this.fromLocation = formatedFromAirport;
        this.toLocation = formatedToAirport;
        this.flightSearch.get('fromAirport')?.setValue(formatedFromAirport.display_name_en);
        this.flightSearch.get('toAirport')?.setValue(formatedToAirport.display_name_en);
        this.flightSearch.get('departureDate')?.setValue(new Date(recentDepartureDate));
        this.flightSearch.get('returnDate')?.setValue(new Date(recentDepartureDate));
      } else {
        // For Multi trip

        let recentDepartureDate = recentDetails.departureDate;

        let formatedFromAirport = {
          airport_ar: '',
          airport_code: recentDetails.fromLocation.airport_code,
          airport_en: recentDetails.fromLocation.airport_en,
          city_ar: '',
          city_en: recentDetails.fromLocation.city_en,
          country_ar: '',
          country_en: recentDetails.fromLocation.country_en,
          display_name_ar: '',
          display_name_en: recentDetails.fromLocation.display_name_en,
          id: '',
          latitude: '',
          longitude: '',
        }
        let formatedToAirport = {
          airport_ar: '',
          airport_code: recentDetails.toLocation.airport_code,
          airport_en: recentDetails.toLocation.airport_en,
          city_ar: '',
          city_en: recentDetails.toLocation.city_en,
          country_ar: '',
          country_en: recentDetails.toLocation.country_en,
          display_name_ar: '',
          display_name_en: recentDetails.toLocation.display_name_en,
          id: '',
          latitude: '',
          longitude: '',
        }
        this.fromLocation = formatedFromAirport;
        this.toLocation = formatedToAirport;
        this.flightSearch.get('fromAirport')?.setValue(formatedFromAirport.display_name_en);
        this.flightSearch.get('toAirport')?.setValue(formatedToAirport.display_name_en);
        this.flightSearch.get('departureDate')?.setValue(new Date(recentDepartureDate));
        this.flightSearch.get('returnDate')?.setValue(new Date(recentDepartureDate));
        this.updateReturnDate();

        this.isMultiCityActive = true;
        this.isRadioActive = false;
        this.toggleTab('multiCity');
        this.addSingleMultiCity('multiCity')
      }
    } else {
      console.error("recentSearches array is empty");
    }
  }


  autoFillData(data: any) {
    console.log('datainit', data)
    this.isRtl = String(localStorage.getItem('languageCode')) === 'ar';

    // Set the locale based on the value of 'isRtl'
    if (this.isRtl) {
      defineLocale('ar', arLocale);
      this.localeService.use('ar'); // Set locale dynamically
    } else {
      defineLocale('en-gb', enGbLocale);
      this.localeService.use('en-gb'); // Set locale dynamically
    }

    // Set the locale for the datepicker
    this.bsConfig = {
      dateInputFormat: 'DD-MM-YYYY',
      containerClass: 'theme-red',
      showWeekNumbers: false,
      locale: this.isRtl ? 'ar' : 'en-gb',
    };

    this.maxDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() + 365);
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.checkScreenWidth();
    // pricing calender
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
    this.currentMonth = currentDate.getMonth();
    this.generateCalendar();

    /* code for from airport search using API */
    this.FromAirportDataSource = new Observable((observer: Observer<string | undefined>) => {

      observer.next(this.flightSearch.get('fromAirport')?.value);
    }).pipe(
      switchMap((query: string) => {
        if (query && query.length >= 3) {
          //console.log(this._apiService.searchAirport(query));
          let resp = this._apiService.searchAirport(query).pipe(
            map((data) => data && data.data || [])
          );
          console.log(resp);
          return resp;
        }
        return of([]);
      })
    );
    this.ToAirportDataSource = new Observable((observer: Observer<string | undefined>) => {

      observer.next(this.flightSearch.get('toAirport')?.value);
    }).pipe(
      switchMap((query: string) => {
        if (query && query.length >= 3) {
          //console.log(this._apiService.searchAirport(query));
          let resp = this._apiService.searchAirport(query).pipe(
            map((data) => data && data.data || [])
          );
          console.log(resp);
          return resp;
        }
        return of([]);
      })
    );

    // set-multicity functionality
    const queryParams = new URLSearchParams(window.location.search);
    const searchType = queryParams.get('searchType');

    if (searchType) {
      console.log('Search Type:', searchType);

      if (searchType.toLowerCase() === 'multicity') {
        document.body.classList.add('searched-multicity');
        console.log('Body class "searched-multicity" added.');
      }
    } else {
      console.log('Search Type not found in the URL.');
    }

    //get route value
    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.requestParams = { ...params.keys, ...params };
    });

    this.searchRequestType = this.requestParams.params.searchType;
    if (this.requestParams.params.searchType === "one-way") {
      // For One Way trip
      this.isOneWayActive = true;
      this.isRadioActive = true;
      let orgDest = this.requestParams.params.originDestination.split('-');
      this.flightSearch.get('returnDate')?.setValue(this.requestParams.params.departureDate);
      this.originDestinations = [
        {
          "originLocationCode": orgDest[0],
          "destinationLocationCode": orgDest[1],
          "departureDate": this.requestParams.params.departureDate
        }
      ]
    } else if (this.requestParams.params.searchType === "round-trip") {
      this.isRoundTripActive = true;
      this.isRadioActive = false;
      this.isMultiCityActive = false;
      let orgDest = this.requestParams.params.originDestination.split('-');
      this.originDestinations = [
        {
          "originLocationCode": orgDest[0],
          "destinationLocationCode": orgDest[1],
          "departureDate": this.requestParams.params.departureDate,
          "returnDate": this.requestParams.params.returnDate
        }
      ]

      this.flightSearch.get('departureDate')?.setValue(new Date(this.requestParams.params.departureDate));
      this.flightSearch.get('returnDate')?.setValue(new Date(this.requestParams.params.departureDate));
    } else {
      // For Multi trip
      this.isMultiCityActive = true;
      this.isRoundTripActive = false;
      this.isRadioActive = false;
      this.toggleTab('multiCity');
      console.log('this.requestParams', this.requestParams);
      let originDestinationArry: any;
      console.log('this.requestParams.params.originDestination.length', this.requestParams.params.originDestination.length);
      this.originDestinations = [];
      originDestinationArry = this.requestParams.params.originDestination
      console.log('originDestinationArry', originDestinationArry);
      // return;
      // for (let index = 0; index < originDestinationArry.length; index++) {
      for (let index = 0; index < this.requestParams.params.originDestination.length; index++) {
        const element = originDestinationArry[index].split('|');
        const dest = element[0].split('-');
        let obj = {
          "originLocationCode": dest[0],
          "destinationLocationCode": dest[1],
          "departureDate": element[1].substring(0, 10)
        }
        this.originDestinations.push(obj);
      }
      console.log('multicity origin', this.originDestinations);
    }

    // Travelers Arry for adult, child, infant
    if (this.requestParams.params.adult !== "0") {
      this.travellers.push({
        "type": "ADULT",
        "count": this.requestParams.params.adult
      });
      this.adultCount = parseInt(this.requestParams.params.adult)
    }
    if (this.requestParams.params.child !== "0") {
      this.travellers.push({
        "type": "CHILD",
        "count": this.requestParams.params.child
      });
      this.childCount = parseInt(this.requestParams.params.child)
    }
    if (this.requestParams.params.infant !== "0") {
      this.travellers.push({
        "type": "HELD_INFANT",
        "count": this.requestParams.params.infant
      });
      this.infantCount = parseInt(this.requestParams.params.infant)
    }
    this.selectedTravelClass = this.requestParams.params.travelClass.replace('_', ' ')



    let isBaggage = this.requestParams.params.isBaggage === 'true';
    let isDirect = this.requestParams.params.isDirect === 'true';

    if (isBaggage) {
      this.isBaggage = true;
    }
    if (isDirect) {
      this.isDirect = true;
    }
    console.log(data);
    let flightRespData = data.data.data;
    let aircrafts = data.data.aircraftList;
    let airline = data.data.airlineList;
    let airports = data.data.airportList;
    this.airlineList = data.data.airlineList;
    this.layoverData = data.data.layover;
    console.log(flightRespData);
    let reqAdultCount = this.requestParams.params.adult;
    let reqChildCount = this.requestParams.params.child;
    let reqInfantCount = this.requestParams.params.infant;
    if (this.requestParams.params.searchType == 'one-way') {
      let element: HTMLElement = document.getElementById('one-way-tab') as HTMLElement;
      // element.click();
      console.log(this.originDestinations)
      let reqFromAirport = this.originDestinations[0].originLocationCode
      let reqToAirport = this.originDestinations[0].destinationLocationCode
      let reqDepartureDate = this.originDestinations[0].departureDate
      let fromAirports = airports.filter(function (item: any) {
        if (item.code == reqFromAirport) {
          return item;
        }
      });
      let toAirport = airports.filter(function (item: any) {
        if (item.code == reqToAirport) {
          return item;
        }
      });
      this.oneWaySummary = {
        fromAirport: fromAirports[0],
        toAirport: toAirport[0],
        departureDate: reqDepartureDate,
        adultCount: reqAdultCount,
        childCount: reqChildCount,
        infantCount: reqInfantCount
      }

      this.flightSearch.get('fromAirport')?.setValue(fromAirports[0].airport_name);
      this.flightSearch.get('toAirport')?.setValue(toAirport[0].airport_name);
      this.flightSearch.get('departureDate')?.setValue(new Date(this.requestParams.params.departureDate));
      this.flightSearch.get('returnDate')?.setValue(new Date(this.requestParams.params.departureDate));
      let formatedFromAirport = {
        airport_ar: '',
        airport_code: fromAirports[0].code,
        airport_en: fromAirports[0].airport_name,
        city_ar: '',
        city_en: fromAirports[0].city_name,
        country_ar: '',
        country_en: fromAirports[0].country_name,
        display_name_ar: '',
        display_name_en: '',
        id: '',
        latitude: '',
        longitude: '',
      }
      let formatedToAirport = {
        airport_ar: '',
        airport_code: toAirport[0].code,
        airport_en: toAirport[0].airport_name,
        city_ar: '',
        city_en: toAirport[0].city_name,
        country_ar: '',
        country_en: toAirport[0].country_name,
        display_name_ar: '',
        display_name_en: '',
        id: '',
        latitude: '',
        longitude: '',
      }
      this.fromLocation = formatedFromAirport;
      this.toLocation = formatedToAirport;
    } else if (this.requestParams.params.searchType == 'round-trip') {
      let element: HTMLElement = document.getElementById('round-trip-tab') as HTMLElement;
      // element.click();
      let reqDeptFromAirport = this.originDestinations[0].originLocationCode
      let reqDeptToAirport = this.originDestinations[0].destinationLocationCode
      let reqRetFromAirport = this.originDestinations[0].destinationLocationCode
      let reqRetToAirport = this.originDestinations[0].originLocationCode

      let reqDepartureDate = this.originDestinations[0].departureDate
      let reqReturnDate = this.originDestinations[0].returnDate

      let deptFromAirports = airports.filter(function (item: any) {
        if (item.code == reqDeptFromAirport) {
          return item;
        }
      });
      let deptToAirport = airports.filter(function (item: any) {
        if (item.code == reqDeptToAirport) {
          return item;
        }
      });

      let retFromAirports = airports.filter(function (item: any) {
        if (item.code == reqRetFromAirport) {
          return item;
        }
      });
      let retToAirport = airports.filter(function (item: any) {
        if (item.code == reqRetToAirport) {
          return item;
        }
      });

      this.roundTripSummary = {
        departureFlight: {
          fromAirport: deptFromAirports[0],
          toAirport: deptToAirport[0],
          departureDate: reqDepartureDate,
        },
        returnFlight: {
          fromAirport: retFromAirports[0],
          toAirport: retToAirport[0],
          returnDate: reqReturnDate,
        },
        adultCount: reqAdultCount,
        childCount: reqChildCount,
        infantCount: reqInfantCount
      }
      this.flightSearch.get('fromAirport')?.setValue(deptFromAirports[0].airport_name);
      this.flightSearch.get('toAirport')?.setValue(deptToAirport[0].airport_name);
      let formatedFromAirport = {
        airport_ar: '',
        airport_code: deptFromAirports[0].code,
        airport_en: deptFromAirports[0].airport_name,
        city_ar: '',
        city_en: deptFromAirports[0].city_name,
        country_ar: '',
        country_en: deptFromAirports[0].country_name,
        display_name_ar: '',
        display_name_en: '',
        id: '',
        latitude: '',
        longitude: '',
      }
      let formatedToAirport = {
        airport_ar: '',
        airport_code: deptToAirport[0].code,
        airport_en: deptToAirport[0].airport_name,
        city_ar: '',
        city_en: deptToAirport[0].city_name,
        country_ar: '',
        country_en: deptToAirport[0].country_name,
        display_name_ar: '',
        display_name_en: '',
        id: '',
        latitude: '',
        longitude: '',
      }
      this.fromLocation = formatedFromAirport;
      this.toLocation = formatedToAirport;
      this.flightSearch.get('departureDate')?.setValue(new Date(this.requestParams.params.departureDate));
      this.flightSearch.get('returnDate')?.setValue(new Date(this.requestParams.params.departureDate));
    } else if (this.requestParams.params.searchType == 'multi-city') {
      let element: HTMLElement = document.getElementById('multi-city-tab') as HTMLElement;
      // element.click();
      console.log(this.originDestinations)
      this.multiCitySummary = {
        adultCount: reqAdultCount,
        childCount: reqChildCount,
        infantCount: reqInfantCount,
        origins: []
      };
      this.originDestinations.forEach((ele: any, index: number) => {
        let originAirport = airports.filter(function (item: any) {
          if (item.code == ele.originLocationCode) {
            return item;
          }
        });
        let destinationAirport = airports.filter(function (item: any) {
          if (item.code == ele.destinationLocationCode) {
            return item;
          }
        });
        let tempMulti = {
          originCode: ele.originLocationCode,
          destinationCode: ele.destinationLocationCode,
          originData: originAirport[0],
          destinationData: destinationAirport[0],
          departureDate: ele.departureDate
        };
        this.multiCitySummary.origins.push(tempMulti);
        //set modify search requested data
        if (index == 0) {
          //set from and to value for first flight
          this.flightSearch.get('fromAirport')?.setValue(originAirport[0].airport_name);
          this.flightSearch.get('toAirport')?.setValue(destinationAirport[0].airport_name);

          let formatedFromAirport = {
            airport_ar: '',
            airport_code: originAirport[0].code,
            airport_en: originAirport[0].airport_name,
            city_ar: '',
            city_en: originAirport[0].city_name,
            country_ar: '',
            country_en: originAirport[0].country_name,
            display_name_ar: '',
            display_name_en: '',
            id: '',
            latitude: '',
            longitude: '',
          }
          let formatedToAirport = {
            airport_ar: '',
            airport_code: destinationAirport[0].code,
            airport_en: destinationAirport[0].airport_name,
            city_ar: '',
            city_en: destinationAirport[0].city_name,
            country_ar: '',
            country_en: destinationAirport[0].country_name,
            display_name_ar: '',
            display_name_en: '',
            id: '',
            latitude: '',
            longitude: '',
          }
          this.fromLocation = formatedFromAirport;
          this.toLocation = formatedToAirport;
          this.flightSearch.get('departureDate')?.setValue(new Date(ele.departureDate));
          this.flightSearch.get('returnDate')?.setValue(new Date(ele.departureDate));
        } else {

          const multicityControl = this.multiCityArray.at(index - 1);

          if (multicityControl) {
            multicityControl.patchValue({
              fromAirport: originAirport[0].airport_name,
              airportCodeFrom: destinationAirport[0].airport_name,
              airportCodeTo: ele.originLocationCode,
              toAirport: ele.destinationLocationCode,
              departureDate: new Date(ele.departureDate)
            });
          }

          this.addMultiCity();
        }
      });

      console.log('multicitySummary', this.multiCitySummary);
    }

    // this.filghtInfo
    flightRespData.forEach((flight: any, keys: any) => {
      // console.log(flight.processed);
      let flightsDetails: any[] = [];

      flight.processed.itineraries.forEach((itinerary: any, itineraryKey: any) => {
        // console.log(itinerary)
        const firstItinerary = itinerary.segments[0];
        const lastItinerary = itinerary.segments[itinerary.segments.length - 1];

        console.log('firstItinerary', firstItinerary);
        console.log('lastItinerary', lastItinerary);
        let departureDate = new Date(firstItinerary.departure.at);
        let arrivalDate = new Date(lastItinerary.arrival.at);
        let arrivalHourFormated = arrivalDate.getHours();
        let arrivalMinuteFormated = arrivalDate.getMinutes();
        let departureHourFormated = departureDate.getHours();
        let departureMinuteFormated = departureDate.getMinutes();
        let arrivalTime = ("0" + arrivalHourFormated).slice(-2) + ':' + ("0" + arrivalMinuteFormated).slice(-2);
        let departureTime = ("0" + departureHourFormated).slice(-2) + ':' + ("0" + departureMinuteFormated).slice(-2);//departureDate.getHours() +':'+ departureDate.getMinutes();
        let departureHour = departureDate.getHours();
        let arrivalHour = arrivalDate.getHours();

        let dayIncrease = false;
        console.log('(arrivalDate.getDate()', arrivalDate.getDate());
        console.log('(arrivalDate.getDate()', departureDate.getDate());
        let arrDate = new Date(String(arrivalDate.getDate()));
        let depDate = new Date(String(departureDate.getDate()));
        console.log('arrDate', arrDate);
        console.log('depDate', depDate);
        let Difference_In_Time = arrDate.getTime() - depDate.getTime();
        // let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
        let Difference_In_Days = arrivalDate.getDate() - departureDate.getDate();
        if (arrivalDate.getDate() > departureDate.getDate()) {
          dayIncrease = true;
        }

        let departureNight = false;
        let departureMorning = false;
        let departureNoon = false;
        let departureEvening = false;

        let arrivalNight = false;
        let arrivalMorning = false;
        let arrivalNoon = false;
        let arrivalEvening = false;
        console.log('departureTime', departureHour);
        //make condition for departure time filter
        if (departureHour >= 0 && departureHour < 6) {
          departureNight = true;
        } if (departureHour >= 6 && departureHour < 12) {
          console.log('found morning flight');
          departureMorning = true;
        } if (departureHour >= 12 && departureHour < 18) {
          console.log('found noon flight');
          departureNoon = true;
        } if (departureHour >= 18 && departureHour <= 23) {
          departureEvening = true;
        }

        //make condition for arrival time filter
        if (arrivalHour >= 0 && arrivalHour < 6) {
          arrivalNight = true;
        } if (arrivalHour >= 6 && arrivalHour < 12) {
          arrivalMorning = true;
        } if (arrivalHour >= 12 && arrivalHour < 18) {
          arrivalNoon = true;
        } if (arrivalHour >= 18 && arrivalHour <= 23) {
          arrivalEvening = true;
        }

        // let arrivalAirline = aircrafts.filter((item: any) => item.code.indexOf(firstItinerary.aircraft.code) > -1)
        let departureAirline = airline.filter(function (item: any) {
          if (item.code == firstItinerary.carrierCode) {
            return item;
          }
        });
        let arrivalAirline = airline.filter(function (item: any) {
          if (item.code == lastItinerary.carrierCode) {
            return item;
          }
        });

        let customSegment = [];
        let withMultipleAirline = false;
        //modify segment information
        itinerary.segments.forEach((segment: any, segmentKey: any) => {
          //get aircract record
          let aircraft = aircrafts.filter(function (item: any) {
            if (item.code == segment.aircraft.code) {
              return item;
            }
          });
          let airlineRec = airline.filter(function (item: any) {
            if (item.code == segment.carrierCode) {
              return item;
            }
          });
          if (segmentKey > 0) {
            console.log('segmentKey', segmentKey);
            if (itinerary.segments[segmentKey].carrierCode != itinerary.segments[segmentKey - 1].carrierCode) {
              withMultipleAirline = true;
            }
          }
          itinerary.segments[segmentKey].aircraftData = aircraft[0];

          //get airport record
          let departureAirport = airports.filter(function (item: any) {
            if (item.code == segment.departure.iataCode) {
              return item;
            }
          });
          let arrivalAirport = airports.filter(function (item: any) {
            if (item.code == segment.arrival.iataCode) {
              return item;
            }
          });
          //to check segment viz pricing option
          let segmentVizFare = flight.processed.travelerPricings[0].fareDetailsBySegment;
          let currentSegmentFare: any;
          segmentVizFare.forEach((ele: any, index: number) => {
            if (ele.segmentId == segment.id) {
              let weight = '';
              let weightUnit = '';
              if (ele.includedCheckedBags.weight != undefined) {
                weight = ele.includedCheckedBags.weight
              }
              if (ele.includedCheckedBags.weightUnit != undefined) {
                weightUnit = ele.includedCheckedBags.weightUnit
              }
              currentSegmentFare = {
                cabin: ele.cabin,
                bagUnit: ele.includedCheckedBags.quantity,
                bagWeight: weight,
                bagWeightUnit: weightUnit
              }
            }
          })

          itinerary.segments[segmentKey].segmentFare = currentSegmentFare;
          itinerary.segments[segmentKey].departureAirportData = departureAirport[0];
          itinerary.segments[segmentKey].arrivalAirportData = arrivalAirport[0];
          itinerary.segments[segmentKey].airlineData = airlineRec[0];
          // itinerary.segments[segmentKey].departureDate = new Date(segment.departure.at);
          itinerary.segments[segmentKey].departureDate = segment.departure.at;
          // itinerary.segments[segmentKey].arrivalDate = new Date(segment.arrival.at);
          itinerary.segments[segmentKey].arrivalDate = segment.arrival.at;
          itinerary.segments[segmentKey].amanities = [];
          itinerary.segments[segmentKey].durationText = this.convertDurationText(segment.duration);
        });

        let tempItinerary = {
          dayIncrease: Math.round(Difference_In_Days),
          arrivalTime: arrivalTime,
          departureAirport: firstItinerary.departure.iataCode,
          duration: itinerary.duration,
          totalDuration: itinerary.durationText,
          totalStop: itinerary.segments.length - 1,
          departureTime: departureTime,
          arrivalAirport: lastItinerary.arrival.iataCode,
          airline: arrivalAirline[0],
          segments: itinerary.segments,
          hasMultipleAirline: withMultipleAirline,
          isNightDepartureFlight: departureNight,
          isMorningDepartureFlight: departureMorning,
          isNoonDepartureFlight: departureNoon,
          isEveningDepartureFlight: departureEvening,

          isNightArrivalFlight: arrivalNight,
          isMorningArrivalFlight: arrivalMorning,
          isNoonArrivalFlight: arrivalNoon,
          isEveningArrivalFlight: arrivalEvening,

          departureAirportData: firstItinerary.departureAirportData,
          arrivalAirportData: lastItinerary.arrivalAirportData,
        };

        flightsDetails.push(tempItinerary);


      });
      let isRefundable = false;
      let priceIncludedBags = false;
      let isCancellable = false;
      //to check whether price is refundable
      if (flight.processed.pricingOptions.refundableFare != undefined) {
        isRefundable = flight.processed.pricingOptions.refundableFare == 'true';
      }
      //to check whether price including checking baggage
      if (flight.processed.pricingOptions.includedCheckedBagsOnly != undefined) {
        priceIncludedBags = flight.processed.pricingOptions.includedCheckedBagsOnly == 'true';
      }
      //to check whether flight cancellable
      if (flight.processed.pricingOptions.noPenaltyFare != undefined) {
        isCancellable = flight.processed.pricingOptions.noPenaltyFare == 'true';
      }

      let mainItinerary = {
        active: false,
        flights: flightsDetails,
        currencyCode: flight.processed.price.currency,
        totalPrice: flight.processed.price.grandTotal,
        refundable: isRefundable,
        priceIncludedBags: priceIncludedBags,
        cancellable: isCancellable,
        originalResponse: flight.original
      };

      // console.log(tempItinerary);
      // this.filghtInfo.push(mainItinerary);
      // this.filghtInfoFilter.push(mainItinerary);
    });

    this.setAirlineMinPrice();
  }

  @Input() isFilterVisible = false; // Initially hidden
  checkScreenWidth(): void {
    this.isFilterVisible = window.innerWidth > 991;
  }

  setDates() {
    const today = new Date();
    this.returnDateMinimum = today;

    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    this.flightSearch.get('returnDate')?.setValue(tomorrow);
  }

  updateReturnDate() {
    // if (departureDate > this.returnDate) {
    // If departure date is greater than return date, update return date to tomorrow's date
    const tomorrow = new Date(this.flightSearch.get('departureDate')?.value);
    tomorrow.setDate(new Date(this.flightSearch.get('departureDate')?.value).getDate() + 1);
    this.flightSearch.get('returnDate')?.setValue(tomorrow);
    //}
  }

  // calculateMinDate(previousDepartureDate: Date | null, currentDepartureDate: Date): Date {
  //   const today = new Date();
  //   if (previousDepartureDate && previousDepartureDate > today) {
  //     return new Date(previousDepartureDate);
  //   } else if (currentDepartureDate && currentDepartureDate > today) {
  //     return new Date(currentDepartureDate);
  //   } else {
  //     return new Date(today.setDate(today.getDate() + 1));
  //   }
  // }  

  calculateMinDateMulti(index: any): Date {
    let previousDepartureDate: Date | undefined;
    let currentDepartureDate: Date | undefined;

    if (index == 0) {
      previousDepartureDate = this.flightSearch.get('departureDate')?.value;
      currentDepartureDate = this.flightSearch.get('departureDate')?.value;
    } else {
      const previousControl = this.multiCityArray.at(index - 1).get('departureDate');
      const currentControl = this.multiCityArray.at(index).get('departureDate');

      // Use type guard to check if the value is a Date
      if (previousControl instanceof Date) {
        previousDepartureDate = previousControl;
      }

      if (currentControl instanceof Date) {
        currentDepartureDate = currentControl;
      }
    }

    const today = new Date();
    if (previousDepartureDate && previousDepartureDate > today) {
      return new Date(previousDepartureDate);
    } else if (currentDepartureDate && currentDepartureDate > today) {
      return new Date(currentDepartureDate);
    } else {
      return new Date(today.setDate(today.getDate() + 1));
    }
  }

  onValueChange(value: Date): void {
    console.log('value change of datepicker', value);
    let plusOne = new Date(value.setDate(value.getDate() + 1));
    if (this.multiCityArray.length > 0) {
      this.multiCityArray.at(0).get('departureDate')?.setValue(value);
    }
  }

  onValueChangeMulti(value: Date, index: number = 0): void {
    console.log('value change of datepicker', value);
    let plusOne = new Date(value.setDate(value.getDate() + 1));
    this.multiCityArray.at(index).get('departureDate')?.setValue(plusOne);
  }



  getTomorrow(): Date {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    return tomorrow;
  }

  toggleDatepicker(datepicker: any, index: number) {
    datepicker.toggle();
    // Perform additional logic if needed
  }

  fromAirportNoResults(event: boolean): void {
    this.fromAirportNoResult = event;
  }

  fromMultiAirportNoResults(event: any, index: number) {
    this.fromMultiAirportNoResult[index] = event;
  }

  toAirportNoResults(event: boolean): void {
    this.toAirportNoResult = event;
  }

  toMultiAirportNoResults(event: any, index: number): void {
    this.toMultiAirportNoResult[index] = event;
  }

  setFromLocation(event: TypeaheadMatch): void {
    // this.defaultDestiniationsAutoSuggestShow = false;
    this.fromLocation = event.item;
  }

  setToLocation(event: TypeaheadMatch): void {
    this.toLocation = event.item;
  }

  formatDate(date = new Date()) {
    const year = date.toLocaleString('default', { year: 'numeric' });
    const month = date.toLocaleString('default', {
      month: '2-digit',
    });
    const day = date.toLocaleString('default', { day: '2-digit' });

    return [year, month, day].join('-');
  }

  redirectToFlightList(form: FormGroup) {
    console.log('from location', this.fromLocation);
    console.log('to location', this.toLocation);
    console.log('departure date', this.formatDate(this.flightSearch.get('departureDate')?.value));
    console.log('return date', this.formatDate(this.flightSearch.get('returnDate')?.value));
    console.log('return > departure', (this.formatDate(this.flightSearch.get('returnDate')?.value) > this.formatDate(this.flightSearch.get('departureDate')?.value)))
    console.log('adult', this.adultCount);
    console.log('child', this.childCount);
    console.log('infant', this.infantCount);
    console.log('travel class', this.selectedTravelClass);
    console.log('is direct', this.isDirect);
    console.log('is baggage', this.isBaggage);

    //unique airport search code for first flight combination
    if (this.fromLocation?.airport_code != undefined) {
      console.log('this.fromLocation', this.fromLocation);
      console.log('this.toLocation', this.toLocation);
      if (this.fromLocation.airport_code == this.toLocation.airport_code) {
        this.flightSearch.controls['fromAirport'].setErrors({ 'incorrect': true });
      } else {
        this.flightSearch.controls['fromAirport'].updateValueAndValidity();
      }
    }

    this.multiCityArray.controls.forEach((control, index) => {
      if (control.get('fromAirport')?.value) {
        if (control.get('airportCodeFrom')?.value === control.get('airportCodeTo')?.value) {
          console.log('Matched index', index);
          // Handle the error or validation as needed
        } else {
          // Add the valid data to the multiCityData array

        }
      }
    });


    //unique airport search code for multicity
    // this.multiCity.forEach((ele: any, index: number) => {
    //   if (ele.fromAirport != "") {
    //     if (ele.airportCodeFrom == ele.airportCodeTo) {
    //       console.log('matched index', index);
    //       this.multiCityGroups[index].controls['fromLocation'].setErrors({ 'incorrect': true });
    //     } else {
    //       this.multiCityGroups[index]?.controls['fromLocation'].updateValueAndValidity();
    //     }
    //   }
    // })

    this.validateSearch();

    // Rest of the existing code...
  }
  validateSearch() {
    this.submitted = true;
    if (this.flightSearch.invalid) {
      const controls = this.flightSearch.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          console.log(controls[name].errors);
          console.log(name);
        }
      }
      console.log('if condition')
      return;
    } else {
      console.log('else');
      let selectedQuery;
      if (this.isMultiCityActive) {

        console.log(this.flightSearch.controls);
        let multiDest: any[] = [];

        multiDest.push(this.fromLocation.airport_code + '-' + this.toLocation.airport_code + '|' + this.formatDate(this.flightSearch.get('departureDate')?.value));

        this.multiCityArray.controls.forEach((control, index) => {
          if (control.get('airportCodeFrom')?.value) {
            multiDest.push(control.get('airportCodeFrom')?.value + '-' + control.get('airportCodeTo')?.value + '|' + this.formatDate(control.get('departureDate')?.value));
          }
        })
        console.log(multiDest);
        selectedQuery = {
          originDestination: multiDest,
          travelClass: this.selectedTravelClass.replace(' ', '_'),
          adult: this.adultCount,
          child: this.childCount !== null ? this.childCount : 0,
          infant: this.infantCount !== null ? this.infantCount : 0,
          search: this.infantCount,
          searchType: this.isMultiCityActive ? 'multi-city' : (this.formatDate(this.flightSearch.get('returnDate')?.value) >= this.formatDate(this.flightSearch.get('departureDate')?.value)) ? 'round-trip' : 'one-way',
          isDirect: this.isDirect,
          isBaggage: this.isBaggage,
        };
      } else {
        selectedQuery = {
          originDestination: this.fromLocation.airport_code + '-' + this.toLocation.airport_code,
          departureDate: this.formatDate(this.flightSearch.get('departureDate')?.value),
          returnDate: this.formatDate(this.flightSearch.get('returnDate')?.value),
          travelClass: this.selectedTravelClass.replace(' ', '_'),
          adult: this.adultCount,
          child: this.childCount !== null ? this.childCount : 0,
          infant: this.infantCount !== null ? this.infantCount : 0,
          search: this.infantCount,
          searchType: this.isRadioActive ? 'one-way' : (this.formatDate(this.flightSearch.get('returnDate')?.value) > this.formatDate(this.flightSearch.get('departureDate')?.value)) ? 'round-trip' : 'one-way',
          isDirect: this.isDirect,
          isBaggage: this.isBaggage,
        };
        console.log('this.fromLocation', this.fromLocation);
        console.log('this.toLocation', this.toLocation);
      }
      console.log(selectedQuery);
      this.router.navigate(['flight/list'], {
        queryParams: selectedQuery
      });
      this.submitted = false;
    }

    // Create an object with the search data
    const searchItem = {

      fromLocation: this.fromLocation,
      toLocation: this.toLocation,
      departureDate: this.formatDate(this.flightSearch.get('departureDate')?.value),
      returnDate: this.formatDate(this.flightSearch.get('returnDate')?.value),
      searchType: this.isMultiCityActive
        ? 'multi-city'
        : this.isRadioActive
          ? 'one-way'
          : this.formatDate(this.flightSearch.get('returnDate')?.value) >= this.formatDate(this.flightSearch.get('departureDate')?.value)
            ? 'round-trip'
            : 'one-way',
      adult: this.adultCount,
      child: this.childCount !== null ? this.childCount : 0,
      infant: this.infantCount !== null ? this.infantCount : 0,
      travelClass: this.selectedTravelClass,
      multiCity: (() => {
        const multiCityData: { fromAirport: string; toAirport: string; airportCodeFrom: string, airportCodeTo: string, departureDate: string }[] = [];
        // this.multiCity.forEach((ele: any, index: number) => {
        this.multiCityArray.controls.forEach((control, index) => {
          if (control.get('fromAirport')?.value) {
            if (control.get('airportCodeFrom')?.value === control.get('airportCodeTo')?.value) {
              console.log('Matched index', index);
              // Handle the error or validation as needed
            } else {
              // Add the valid data to the multiCityData array
              multiCityData.push({
                fromAirport: control.get('fromAirport')?.value,
                toAirport: control.get('toAirport')?.value,
                airportCodeFrom: control.get('airportCodeFrom')?.value,
                airportCodeTo: control.get('airportCodeTo')?.value,
                departureDate: control.get('departureDate')?.value
                // ... other properties from the multiCity element
              });
            }
          }
        });
        return multiCityData; // Return the processed multiCityData
      })(),
      // Add other relevant search data here
    };

    // Add the search item to the recent searches array
    this.recentSearches.unshift(searchItem);

    // Keep only the last 4 searches
    this.recentSearches = this.recentSearches.slice(0, 4);

    // Update the local storage with the recent searches array
    localStorage.setItem('recentFlightSearches', JSON.stringify(this.recentSearches));

  }

  addDiv() {
    if (this.dynamicDivs.length < 4) {
      this.dynamicDivs.push({});
    }
  }

  removeDiv(index: number) {
    this.dynamicDivs.splice(index, 1);
  }

  trackByFn(index: number, item: any) {
    return index;
  }



  changeCode(arr: any) {
    this.selectedTravelClass = arr.name.replace('_', ' ');
    this.colorvariable = arr.id;
  }

  contentdropdown: boolean = false;
  dropdownOpen() {
    this.contentdropdown = !this.contentdropdown;
  }

  adultCount: number = 1;
  infantCount: any = null;
  childCount: any = null;

  incrementAdultText() {
    let adultChildSum = this.adultCount + this.childCount;

    if (this.adultCount > 9) {
      this.adultCount = 1;
    }
    if (adultChildSum > 9) {
      this.adultCount = 0;
    }
    if (this.adultCount == null || this.adultCount == 0) {
      this.adultCount = 1;
    }
    if (this.infantCount > this.adultCount) {
      this.infantCount = this.adultCount;
    }
  }

  incrementChildText() {
    let adultChildSum = this.adultCount + this.childCount;
    if (adultChildSum > 9) {
      this.childCount = 0;
    }
    if (this.childCount == null) {
      this.childCount = 0;
    }
  }

  incrementInfantText() {

    if (this.infantCount < 9) {
      if (this.infantCount > this.adultCount) {
        this.infantCount = this.adultCount;
      }
    }
    if (this.infantCount == null) {
      this.infantCount = 0;
    }

    if (this.infantCount > this.adultCount) {
      this.infantCount = this.adultCount;
    }
  }

  incrementAdult() {
    let adultChildSum = this.adultCount + this.childCount;
    if (adultChildSum < 9) {
      if (this.adultCount < 9) {
        this.adultCount++;
      }
    }
  }

  decrementAdult() {
    if (this.adultCount > 1) {
      this.adultCount--;
    }
    if (this.infantCount > this.adultCount) {
      this.infantCount--;
    }
  }

  incrementInfant() {

    if (this.infantCount < 9) {
      if (this.infantCount < this.adultCount) {
        this.infantCount++;
      }
    }
  }

  decrementInfant() {
    if (this.infantCount > 0) {
      this.infantCount--;
    }
    if (this.infantCount == 0) {
      this.infantCount = null;
    }
  }

  incrementChild() {
    let adultChildSum = this.adultCount + this.childCount;
    if (adultChildSum < 9) {
      if (this.childCount < 9) {
        this.childCount++;
      }
    }
  }

  decrementChild() {
    if (this.childCount > 0) {
      this.childCount--;
    }
    if (this.childCount == 0) {
      this.childCount = null;
    }
  }

  switchLocationMulticity(index: number) {
    var FromLocation = this.multiCityArray.at(index).get('airportCodeFrom')?.value;
    var ToLocation = this.multiCityArray.at(index).get('airportCodeTo')?.value;
    var FromLcocationName = this.multiCityArray.at(index).get('fromAirport')?.value;
    var ToLocationName = this.multiCityArray.at(index).get('toAirport')?.value;

    this.multiCityArray.at(index).get('fromAirport')?.setValue(ToLocationName);
    this.multiCityArray.at(index).get('toAirport')?.setValue(FromLcocationName);
    this.multiCityArray.at(index).get('airportCodeFrom ')?.setValue(ToLocation);
    this.multiCityArray.at(index).get('airportCodeTo')?.setValue(FromLocation);

    let tmpFromLocation = this.fromLocationMulti[index];
    this.fromLocationMulti[index] = this.toLocationMulti[index];
    this.toLocationMulti[index] = tmpFromLocation;

  }

  switchLocation() {
    let fromName = this.flightSearch.get("fromAirport")?.value;
    let toName = this.flightSearch.get("toAirport")?.value;
    this.flightSearch.get("fromAirport")?.setValue(toName, { emitEvent: false });
    this.flightSearch.get("toAirport")?.setValue(fromName, { emitEvent: false });
    let tmpFromLocation = this.fromLocation;
    this.fromLocation = this.toLocation;
    this.toLocation = tmpFromLocation;
  }

  location: any;
  isRtl: boolean;


  //myDatepicker: FormGroup;
  bsRangeValue: Date;
  isRadioActive: boolean = true;
  daterangepickerModel?: Date[];
  myDateValue!: Date;

  config: SwiperOptions = {
    autoplay: {
      delay: 5000
    },
    pagination: { el: '.swiper-pagination', clickable: true },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
  };

  get fs() { return this.flightSearch.controls; }
  // get m() { return this.fs['multiCityData'] as FormArray; }
  //get multiCityGroups() { return this.m.controls as FormGroup[]; }

  getSearchAirport(query: string) {
    let AirportDataSource = new Observable((observer: Observer<string | undefined>) => {
      observer.next(query);
    }).pipe(
      switchMap((query: string) => {
        if (query && query.length >= 3) {
          let resp = this._apiService.searchAirport(query).pipe(
            map((data) => data && data.data || [])
          );
          console.log(resp);
          return resp;
        }
        return of([]);
      }));

    return AirportDataSource;
  }

  setMultiFromLocation(event: TypeaheadMatch, index: number, type: string): void {
    // this.defaultDestiniationsAutoSuggestShow = false;
    console.log(event);
    console.log(index);
    if (type == 'from') {
      this.multiCityArray.at(index).get('airportCodeFrom')?.setValue(event.item.airport_code);
      this.fromLocationMulti[index] = event.item;
    }
    if (type == 'to') {
      this.multiCityArray.at(index).get('airportCodeTo')?.setValue(event.item.airport_code);
      this.toLocationMulti[index] = event.item;
    }
  }

  createForm() {

    this.flightSearch = this.fb.group({
      fromLocation: ['', [Validators.required, Validators.minLength(3)]],
      toLocation: ['', [Validators.required, Validators.minLength(3)]],
      departureDate: [''],
      returnDate: ['']
    });

    this.flightSearch.get("departureDate")?.valueChanges.subscribe(x => {
      this.updateReturnDate();
    });

  }

  resetMultiCity(tabName: string) {
    this.toggleTab(tabName);
    this.multiCityArray.clear();
  }

  showAddButton: boolean = true;


  addSingleMultiCity(tabName: string = 'multiCity') {
    // if (this.multiCityGroups.length == 0) {
    //   const newId = this.generateUniqueId();
    //   const newFormGroup = this.formBuilder.group({
    //     id: newId,
    //     fromLocation: ['', Validators.required],
    //     toLocation: ['', [Validators.required]],
    //     departureDate: ['', Validators.required],

    //   });
    //   this.m.push(newFormGroup);

    //   const newMultiCityItem = {
    //     fromAirport: '',
    //     airportCodeFrom: '',
    //     airportCodeTo: '',
    //     toAirport: '',
    //     departureDate: new Date()
    //   };

    //   this.multiCity.push(newMultiCityItem);
    //   this.toggleTab(tabName);
    // }
    this.toggleTab(tabName);
    this.addMultiCity();
  }


  generateUniqueId(): number {
    // Implement a function to generate a unique ID (e.g., using timestamp or a unique counter)
    // Return a unique number for each call to this function
    // Example implementation:
    return new Date().getTime();
  }

  removeMultiCity(index: number) {

    this.multiCityArray.removeAt(index);
    this.departureDates.splice(index, 1); // Remove the corresponding departure date

    if (this.multiCityArray.length < 5) {
      this.showAddButton = true; // Show the button when a div is removed and the length is less than 4
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.flightSearch.controls;
  }

  convertDurationText(duration: string) {
    // Regular expression pattern to extract hours and minutes
    let match = duration.match(/PT(?:(\d+)H)?(?:(\d+)M)?/);

    let hours = "0";
    let minutes = "0";
    if (match) {
      if (match[1] != undefined) {
        hours = match[1];
      }
      if (match[2] != undefined) {
        minutes = match[2];
      }
    }
    let formatedTime = hours + 'h ' + minutes + 'm ';

    return formatedTime;
  }

  setAirlineMinPrice() {
    let flightPrice: any = [];
    this.filghtInfo.forEach((flightData: any, flightIndex: number) => {
      let airlinePrice = {
        airline: '',
        price: flightData.totalPrice,
        airlineData: '',
        hasMultipleAirline: false,
        selected: false
      };
      flightData.flights.forEach((flight: any, index: number) => {
        airlinePrice.hasMultipleAirline = flight.hasMultipleAirline;
        flight.segments.forEach((segment: any, segIndex: number) => {
          airlinePrice.airline = segment.carrierCode
          airlinePrice.airlineData = segment.airlineData
        })
      });
      flightPrice.push(airlinePrice);
    });
    const groupedAirline = flightPrice.reduce((groups: any, data: any) => {
      const group = data.airline;
      if (!groups[group]) {
        groups[group] = [];
      }
      groups[group].push(data);
      return groups;
    }, {});

    console.log('flightPrice', flightPrice);
    console.log('groupedAirline', groupedAirline);
    console.log('Object.values(groupedAirline).length', Object.values(groupedAirline).length)
    const priceGroupArray = Object.values(groupedAirline);
    console.log('priceGroupArray', priceGroupArray)
    priceGroupArray.forEach((pricegroup: any, index: number) => {
      this.airlineMinPriceList.push(pricegroup[0]);
    });
    console.log('this.airlineMinPriceList', this.airlineMinPriceList)
  }

  generateCalendar() {
    this.calendarDays = [];
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();

    for (let month = currentMonth; month < 12; month++) {
      const daysInMonth = new Date(this.currentYear, month + 1, 0).getDate();

      for (let day = month === currentMonth ? currentDay : 1; day <= daysInMonth; day++) {
        const date = new Date(this.currentYear, month, day);
        const monthName = this.months[date.getMonth()];
        const dayName = this.daysOfWeek[date.getDay()];
        const formattedDate = date.getDate();
        const price = this.prices[day - 1]; // Subtract 1 because array index starts from 0
        const currencySymbol = 'SAR';
        const isActive = date.toDateString() === currentDate.toDateString();

        this.calendarDays.push({
          monthName: monthName,
          dayName: dayName,
          formattedDate: formattedDate,
          price: price,
          currencySymbol: currencySymbol,
          isActive: isActive
        });
      }
    }
  }

  toggleTab(tab: string) {
    this.isOneWayActive = tab === 'oneWay';
    this.isRoundTripActive = tab === 'roundTrip';
    this.isMultiCityActive = tab === 'multiCity';
    this.isOtherDivHidden = !this.isOneWayActive;
    if (tab == 'oneWay') {
      this.isRadioActive = true;
      this.isRoundTripActive = false;
      this.isMultiCityActive = false;
    }
    if (tab == 'roundTrip') {
      this.isRoundTripActive = true;
      this.isRadioActive = false;
      this.isMultiCityActive = false;
    }
    if (tab == 'multiCity') {
      this.isMultiCityActive = true;
      this.isRadioActive = false;
      this.isRoundTripActive = false;
    }
  }
}
